<template>
    <div>
        <transition name="side-left">
            <div class="mobile-menu" v-if="modalOpen" ref="sidebar">
                <VueMenu v-bind:context="context"></VueMenu>
            </div>
        </transition>
        <transition name="fade">
            <button class="menu-shade"
                    v-if="modalOpen"
                    v-on:click.self="closeModal"
                    aria-label="Sulje valikko"
            ></button>
        </transition>
    </div>
</template>

<script>
import VueMenu from "./VueMenu";
import {enableLock, disableLock} from '../utils/scroll-lock';

export default {
    props: ['context'],
    components: {
        'VueMenu': VueMenu,
    },
    data: function() {
        return {
            modalOpen: false,
        }
    },
    methods: {
        openModal() {
            this.modalOpen = true;
          document.documentElement.classList.add('menu-open');
            enableLock();
        },
        closeModal() {
            this.modalOpen = false;
          document.documentElement.classList.remove('menu-open');
            disableLock();
        }
    },
    mounted() {
      window.addEventListener('pagehide', (event) => {
        if (event.persisted) {
          this.closeModal();
        }
      });
        document.addEventListener('open-modal-menu', (event) => {
            if (window.gtag) {
                gtag('event', 'Open', {
                    event_category: 'Menu',
                });
            }
            this.openModal();
        })
    }
}
</script>
